import { t } from "@/i18n-js/instance";
import circleAIBotAvatar from "../../assets/icons/CircleAIBot-avatar.png";

const BotAvatar = () => (
  <div className="flex h-[20px] w-[20px] shrink-0 justify-center overflow-hidden rounded-full">
    <img
      src={circleAIBotAvatar}
      alt={t("help_widget.home_page.circle_ai_bot_alt")}
      className="h-full w-full object-contain"
      loading="eager"
    />
  </div>
);

export default BotAvatar;
